import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BaseSubscriberAbstract } from '@bling-fe/shared/utils';

@Component({
  selector: 'bl-select-modal-base',
  templateUrl: './select-modal-base.component.html',
  styleUrls: ['./select-modal-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule, SvgIconComponent, TranslateModule, NgIf]
})
export class SelectModalBaseComponent extends BaseSubscriberAbstract {
  @Input({ required: true }) title!: string;
  @Input() searchPlaceholder: string = this.translate.instant(
    'COMMON.LABELS.SEARCH'
  );
  @Input() showClose = true;
  @Input() showHeaderBorder = false;
  @Input() showSearchBar = true;
  @Output() search = new EventEmitter<string>();
  @Output() closeClick = new EventEmitter<void>();

  constructor(private translate: TranslateService) {
    super();
  }
}
